<section class="container-fluid">

  <form novalidate autocomplete="off" name="ediTranslationForm">
    <div class="row">
      <div class="col-sm-4 col-md-2"></div>
      <div class="col-sm-4 col-md-8">
        <div class="form-group ">
          <label class="lblCls">
            Option Code
          </label>
          <input type="text" kendoTextBox class="form-control" name="optionCode" [(ngModel)]="editTranslation.optionCode" />
        </div>

        <div class="form-group ">
          <label class="lblCls">
            Option Translation
          </label>
          <input type="text" kendoTextBox class="form-control" name="optionTranslation" [(ngModel)]="editTranslation.optionTranslation" />
        </div>
        <div class="form-group">
          <label class="lblCls mr-2">
            Option Applicable Products
          </label>
          <kendo-multiselect [data]="productCode"
                             [(ngModel)]="value" name="optionApplicableProducts" [filterable]="true"(filterChange)="handleFilter($event)"></kendo-multiselect>
        </div>
        <div class="row">
          <div class="form-group">
            <div class="btn-group float-right" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="editTranslationToSave()">
                Update<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      [routerLink]="['../']">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4 col-md-2"></div>
    </div>
  </form>
</section>
